import React from 'react';
import '../styles/PrivacyPolicy.css';

function AwatiMotorsPrivacy() {
  return (
    <div className="privacy-policy-container">
      <header className="privacy-header">
        <h1>Privacy Policy</h1>
        <p className="company-name">Awati Motors Application</p>
        <p className="last-updated">Effective Date: November 10, 2025</p>
      </header>

      <main className="privacy-content">
        <section className="policy-intro">
          <p className="intro-text">
            This privacy policy applies to the Awati Motors app (hereby referred to as "Application") for mobile devices 
            that was created by ITPL (hereby referred to as "Service Provider") as a Free service. This service is intended 
            for use "AS IS".
          </p>
        </section>

        <section className="policy-section">
          <h2>1. Information Collection and Use</h2>
          <p>
            The Application collects information when you download and use it. This information may include:
          </p>
          <ul>
            <li><strong>Device Information:</strong> Your device's Internet Protocol address (e.g., IP address)</li>
            <li><strong>Usage Analytics:</strong> The pages of the Application that you visit, the time and date of your visit, and the time spent on those pages</li>
            <li><strong>Application Usage:</strong> The time spent on the Application</li>
            <li><strong>Operating System:</strong> The operating system you use on your mobile device</li>
          </ul>
          <p className="highlight-note">
            <strong>Note:</strong> The Application does not gather precise information about the location of your mobile device.
          </p>
          <p>
            The Service Provider may use the information you provided to contact you from time to time to provide you with 
            important information, required notices, and marketing promotions.
          </p>
          <p>
            For a better experience while using the Application, the Service Provider may require you to provide us with 
            certain personally identifiable information, including but not limited to your email address 
            (sparkcomputer555@gmail.com). The information that the Service Provider requests will be retained by them and 
            used as described in this privacy policy.
          </p>
        </section>

        <section className="policy-section">
          <h2>2. Third Party Access</h2>
          <p>
            Only aggregated, anonymized data is periodically transmitted to external services to aid the Service Provider 
            in improving the Application and their service. The Service Provider may share your information with third parties 
            in the ways that are described in this privacy statement.
          </p>
          <p className="subsection-title">Third-Party Services Used:</p>
          <ul>
            <li><strong>Google Play Services</strong></li>
            <li><strong>Google Analytics for Firebase</strong></li>
            <li><strong>Firebase Crashlytics</strong></li>
          </ul>
          <p>
            Each of these services has their own Privacy Policy regarding the handling of data. Please review their respective 
            privacy policies for more information.
          </p>
        </section>

        <section className="policy-section">
          <h2>3. Information Disclosure</h2>
          <p>
            The Service Provider may disclose User Provided and Automatically Collected Information:
          </p>
          <ul>
            <li>As required by law, such as to comply with a subpoena or similar legal process</li>
            <li>When they believe in good faith that disclosure is necessary to protect their rights, protect your safety or the safety of others, investigate fraud, or respond to a government request</li>
            <li>With their trusted service providers who work on their behalf, do not have an independent use of the information we disclose to them, and have agreed to adhere to the rules set forth in this privacy statement</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>4. Opt-Out Rights</h2>
          <p>
            You can stop all collection of information by the Application easily by uninstalling it. You may use the standard 
            uninstall processes as may be available as part of your mobile device or via the mobile application marketplace or network.
          </p>
        </section>

        <section className="policy-section">
          <h2>5. Data Retention Policy</h2>
          <p>
            The Service Provider will retain User Provided data for as long as you use the Application and for a reasonable time 
            thereafter. If you'd like them to delete User Provided Data that you have provided via the Application, please contact 
            them at <strong>sparkcomputer555@gmail.com</strong> and they will respond in a reasonable time.
          </p>
        </section>

        <section className="policy-section">
          <h2>6. Children's Privacy</h2>
          <p>
            The Service Provider does not use the Application to knowingly solicit data from or market to children under the age of 13.
          </p>
          <p>
            The Application does not address anyone under the age of 13. The Service Provider does not knowingly collect personally 
            identifiable information from children under 13 years of age. In the case the Service Provider discovers that a child 
            under 13 has provided personal information, the Service Provider will immediately delete this from their servers.
          </p>
          <p>
            If you are a parent or guardian and you are aware that your child has provided us with personal information, please 
            contact the Service Provider at <strong>sparkcomputer555@gmail.com</strong> so that they will be able to take the 
            necessary actions.
          </p>
        </section>

        <section className="policy-section">
          <h2>7. Security</h2>
          <p>
            The Service Provider is concerned about safeguarding the confidentiality of your information. The Service Provider 
            provides physical, electronic, and procedural safeguards to protect information the Service Provider processes and maintains.
          </p>
        </section>

        <section className="policy-section">
          <h2>8. Changes to This Privacy Policy</h2>
          <p>
            This Privacy Policy may be updated from time to time for any reason. The Service Provider will notify you of any changes 
            to the Privacy Policy by updating this page with the new Privacy Policy. You are advised to consult this Privacy Policy 
            regularly for any changes, as continued use is deemed approval of all changes.
          </p>
        </section>

        <section className="policy-section">
          <h2>9. Your Consent</h2>
          <p>
            By using the Application, you are consenting to the processing of your information as set forth in this Privacy Policy 
            now and as amended by us.
          </p>
        </section>

        <section className="policy-section">
          <h2>10. Contact Us</h2>
          <p>
            If you have any questions regarding privacy while using the Application, or have questions about the practices, please 
            contact the Service Provider via email:
          </p>
          <div className="contact-info">
            <p>
              <strong>Email:</strong> <a href="mailto:sparkcomputer555@gmail.com">sparkcomputer555@gmail.com</a>
            </p>
            <p>
              <strong>Service Provider:</strong> ITPL
            </p>
            <p>
              <strong>Application:</strong> Awati Motors
            </p>
          </div>
        </section>
      </main>

      <footer className="privacy-footer">
        <p>&copy; 2025 Awati Motors. All rights reserved.</p>
        <p className="footer-note">This privacy policy is effective as of November 10, 2025</p>
      </footer>
    </div>
  );
}

export default AwatiMotorsPrivacy;
